import { gql } from "@apollo/client";

export const GET_STATUS_OPTIONS = gql`
  query {
    getStatusOptions
  }
`;